import * as React from "react";
import { Paper } from "@mui/material";
import "./CoursesData.css";
import TabComponent from "../Components/ReusableComponent/TabComponent";
import courses from "../assets/images/HomeDesk/CoursesOffered.png";

export default function CourseData() {
  const tabData = [
    { id: "MBA", label: "MBA", content: <MBA /> },
    { id: "PH.D", label: "PH.D", content: <PHD /> },
    { id: "BBA", label: "BBA", content: <BBA /> },
  ];

  return (
    <>
      <div className="box">
        <Paper elevation={2}>
          <div className="text-center py-4" data-aos="fade-left">
            <img src={courses} height={100} />
          </div>

          <TabComponent
            tabData={tabData}
            tabName={sessionStorage.getItem("menuName")}
          />
        </Paper>
      </div>
    </>
  );
}

export function MBA() {
  return (
    <>
      <div className="m-0">
        <div className="text-center">
          <div>
            <h5 className="text-bold my-2 mb-5">MBA Specialisations</h5>

            <div
              className="d-flex justify-content-center flex-wrap align-items-center gap-5 mb-4"
              data-aos="fade-left"
            >
              <div className="box">
                <div className="item item2 mx-auto">
                  <a href="#">
                    <div className="img img1"></div>
                    <p className="title">MBA</p>
                  </a>
                </div>
                <p className="description">Business Analytics</p>
              </div>

              <div className="box">
                <div className="item item2 mx-auto">
                  <a href="#">
                    <div className="img img4"></div>
                    <p className="title">MBA</p>
                  </a>
                </div>
                <p className="description">Marketing Management</p>
              </div>

              <div className="box">
                <div className="item item2 mx-auto">
                  <a href="#">
                    <div className="img img5"></div>
                    <p className="title">MBA</p>
                  </a>
                </div>
                <p className="description">Financial Management</p>
              </div>

              <div className="box">
                <div className="item item2 mt-5 mx-auto">
                  <a href="#">
                    <div className="img img2"></div>
                    <p className="title">MBA</p>
                  </a>
                </div>
                <p className="description">
                  Operations Supply Chain Management (OSCM)
                </p>
              </div>

              <div className="box">
                <div className="item item2 mt-5 mx-auto">
                  <a href="#">
                    <div className="img img3"></div>
                    <p className="title">MBA</p>
                  </a>
                </div>
                <p className="description">Human Resources Management</p>
              </div>
            </div>
          </div>
        </div>
        {/* <h5 className="text-bold pt-5 mb-4 mt-5 ">ONLY as MINOR Specializations (MBA)</h5>
            <div className="d-flex justify-content-center flex-wrap align-items-center gap-4 my-5" data-aos="fade-left">
              <div className='box'>
                <div className="item item2 mx-auto">
                  <a href="#">
                    <div className="img img6"></div>
                    <p className="title">MBA</p>
                  </a>
                </div>
                <p className="description">Tourism & Hospitality Management (THM)</p>
              </div>

              <div className='box'>
                <div className="item item2 mx-auto">
                  <a href="#">
                    <div className="img img7"></div>
                    <p className="title">MBA</p>
                  </a>
                </div>
                <p className="description">Rural & Agribusiness Management (RABM)</p>
              </div>

              <div className='box'>
                <div className="item item2 mx-auto">
                  <a href="#">
                    <div className="img img8"></div>
                    <p className="title">MBA</p>
                  </a>
                </div>
                <p className="description">International Business Management (IB)</p>
              </div>
              <div className='box'>
                <div className="item item2 mx-auto">
                  <a href="#">
                    <div className="img img9"></div>
                    <p className="title">MBA</p>
                  </a>
                </div>
                <p className="description">Pharma & Healthcare Management (PHM)</p>
              </div>
            </div> */}

        <div
          className="mba-info mt-5"
          style={{
            backgroundColor: "#f4f7f9",
            padding: "30px",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          <h4
            className="text-bold"
            style={{
              textAlign: "left",
              fontSize: "25px",
              color: "#333",
              marginBottom: "15px",
            }}
          >
            MBA
          </h4>
          <h5
            className="text-bold"
            style={{
              textAlign: "left",
              fontSize: "20px",
              color: "#333",
              marginBottom: "10px",
            }}
          >
            Intake Capacity :
          </h5>
          <p style={{ fontSize: "18px", color: "#555", marginBottom: "10px" }}>
            180 Students
          </p>
          <p style={{ fontSize: "18px", color: "#555" }}>
            DTE Choice Code:{" "}
            <strong style={{ color: "#0056b3" }}>663110110</strong>
          </p>

          <h5
            className="text-bold mt-4"
            style={{
              textAlign: "left",
              fontSize: "20px",
              color: "#333",
              marginBottom: "10px",
            }}
          >
            Program Overview :
          </h5>
          <p
            style={{
              fontSize: "16px",
              color: "#555",
              lineHeight: "1.6",
              marginBottom: "20px",
              textAlign: "justify",
            }}
          >
            MIBM offers a two-year full-time Masters in Business Administration
            (MBA) program. The program equips students with competent skills
            required by corporations at both domestic and international levels.
            The Choice-Based Credit System (CBCS) is adopted in the program,
            which provides a wide range of choices to students in terms of
            curriculum, enabling them to make their own decisions.
          </p>

          <h5
            className="text-bold mt-4"
            style={{
              textAlign: "left",
              fontSize: "20px",
              color: "#333",
              marginBottom: "10px",
            }}
          >
            OBJECTIVES OF MBA PROGRAM :
          </h5>
          <ul
            style={{
              fontSize: "16px",
              color: "#555",
              lineHeight: "1.6",
              marginLeft: "20px",
              listStyleType: "disc",
              textAlign: "justify",
            }}
          >
            <li style={{ marginBottom: "10px" }}>
              To equip students with the requisite knowledge, skills, and the
              right attitude necessary to provide effective leadership in a
              global environment.
            </li>
            <li style={{ marginBottom: "10px" }}>
              To develop competent management professionals with strong ethical
              values, capable of assuming a pivotal role in various sectors of
              the Indian economy and society, aligned with national priorities.
            </li>
            <li style={{ marginBottom: "10px" }}>
              To develop proactive thinking to perform effectively in the
              dynamic socio-economic and business ecosystem.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export function PHD() {
  return (
    <>
      <div className="m-0">
        <div className="text-center">
          <div>
            <h5 className="text-bold  mb-5">PHD</h5>
            <div
              className="d-flex justify-content-center flex-wrap align-items-center gap-4"
              data-aos="fade-left"
            >
              <div className="box">
                <div className="item item2 mx-auto">
                  <a href="#">
                    <div className="img img4"></div>
                    <p className="title">PHD</p>
                  </a>
                </div>
                <p className="description">Financial Phd</p>
              </div>
              <div className="box">
                <div className="item item2 mx-auto">
                  <a href="#">
                    <div className="img img11"></div>
                    <p className="title">PHD</p>
                  </a>
                </div>
                <p className="description">Organizational Phd</p>
              </div>
              <div className="box">
                <div className="item item2 mx-auto">
                  <a href="#">
                    <div className="img img4"></div>
                    <p className="title">PHD</p>
                  </a>
                </div>
                <p className="description">Marketing Specialization Phd</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export function BBA() {
  return (
    <>
      <div className="m-0">
        <div className="text-center">
          <h5 className="text-bold  mb-5">BBA</h5>{" "}
          <div
            className="d-flex justify-content-center flex-wrap align-items-center gap-4"
            data-aos="fade-left"
          >
            <div className="box">
              <div className="item item2 mx-auto">
                <a href="#">
                  <div className="img img4"></div>
                  <p className="title">BBA</p>
                </a>
              </div>
              <p className="description">Marketing Management</p>
            </div>
            <div className="box">
              <div className="item item2 mx-auto">
                <a href="#">
                  <div className="img img5"></div>
                  <p className="title">BBA</p>
                </a>
              </div>
              <p className="description">Finance Management </p>
            </div>
            <div className="box">
              <div className="item item2 mx-auto">
                <a href="#">
                  <div className="img img3"></div>
                  <p className="title">BBA</p>
                </a>
              </div>
              <p className="description">Human Resource Management</p>
            </div>
          </div>
          {/* <div>
            <h5 className="text-bold my-2 mb-5">BBA Program Overview</h5>

            <div
              className="d-flex justify-content-center flex-wrap align-items-center gap-5 mb-4"
              data-aos="fade-left"
            >
               <div className="box"> 
                <div className="item item2 mx-auto">
                  <a href="#">
                    <div className="img img1"></div>
                    <p className="title">BBA</p>
                  </a>
                </div>
                <p className="description">Business Administration</p>
              </div>
            </div>
          </div> */}
        </div>

        <div
          className="bba-info mt-5"
          style={{
            backgroundColor: "#f4f7f9",
            padding: "30px",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          <h4
            className="text-bold"
            style={{
              textAlign: "left",
              fontSize: "25px",
              color: "#333",
              marginBottom: "15px",
            }}
          >
            BBA
          </h4>
          <h5
            className="text-bold"
            style={{
              textAlign: "left",
              fontSize: "20px",
              color: "#333",
              marginBottom: "10px",
            }}
          >
            Intake Capacity :
          </h5>
          <p
            style={{
              fontSize: "18px",
              color: "#555",
              marginBottom: "10px",
              textAlign: "justify", // Justify this paragraph
              textJustify: "inter-word", // Spread out words
            }}
          >
            120 Students
          </p>

          <h5
            className="text-bold mt-4"
            style={{
              textAlign: "left",
              fontSize: "20px",
              color: "#333",
              marginBottom: "10px",
            }}
          >
            Program Overview :
          </h5>
          <p
            style={{
              fontSize: "18px",
              color: "#555",
              lineHeight: "1.6",
              marginBottom: "20px",
              textAlign: "justify", // Justify this paragraph
              textJustify: "inter-word", // Spread out words
            }}
          >
            BBA is a professional undergraduate programme aimed at inculcating
            managerial and entrepreneurial attitude and skills amongst the
            learners. This programme is designed to provide a basic
            understanding of Management Education and prepare the students to
            avail the opportunities available in the Management Profession. It
            also helps them to become successful business leaders by creating
            self-employment opportunities. It is basically a development
            programme for enhancing leadership qualities and encouraging the
            students to build the required business acumen.
          </p>
        </div>
      </div>
    </>
  );
}
